import styled from 'styled-components';

import { Vertical } from 'atoms/layout/flex';

import { Hero } from './Hero';
import { Navbar } from './Navbar';
import { OurCompetitions } from './OurCompetitions';

const NavbarContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  width: fit-content;
`;

export const HowToPlay = ({ cards }: { cards: string[] }) => {
  return (
    <Vertical>
      <NavbarContainer>
        <Navbar />
      </NavbarContainer>
      <Hero cards={cards} />
      <OurCompetitions />
    </Vertical>
  );
};
